export default __webpack_public_path__ + "static/media/privacy.8d2fe55f.png";